<template>
    <div class="col-12" >
        <fair-image
            :image-id="member.photo ? member.photo.id : null"
            rounded = "circle"
            class="small-item-pic-circle"
        />
        <div class="small-item-content">
            <span class="small-item-user">{{member.first_name}} {{ member.last_name }}</span>
        </div>
    </div>
</template>

<script>

    import FairImage from "../FairImage";

    export default {
        name: "small-member-item",
        components: {FairImage},
        props: {
            member: {
                type: Object,
                default: null
            }
        }
    }
</script>

<style scoped>
</style>
